import { render, staticRenderFns } from "./ReviewHeader.vue?vue&type=template&id=747663b5&"
import script from "./ReviewHeader.vue?vue&type=script&lang=js&"
export * from "./ReviewHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReviewHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports